module.exports = __webpack_public_path__ + "static/media/productLanding.25e0137c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footers/productLanding.png
// module id = 1237
// module chunks = 0